module.exports = __webpack_public_path__ + "static/img/table-individual.12bd52e0.png";